
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The URL of the image, e.g. `}{`\``}<a parentName="p" {...{
        "href": "https://integration.seek.com/awsk/button-images/seek/en/accent.svg%5C%60"
      }}>{`https://integration.seek.com/awsk/button-images/seek/en/accent.svg\\\``}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;